"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmVariableGridLayoutElement = registerBmVariableGridLayoutElement;
exports.getVariableGridStyles = getVariableGridStyles;
exports.registerBmVariableGridLayout = registerBmVariableGridLayout;
exports.renderBmVariableGridLayout = exports.BmVariableGridLayout = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _uiElements = require("@blue/ui-elements");

var _element = require("@blue/element");

var _layoutRegistry = require("../../registry/layout-registry");

var _utils = require("../../../utils");

var _itemFactory = require("../items/item-engine/item-factory");

var _renderVariableLayout = require("./render-variable-layout");

var _renderGridLayout = require("./render-grid-layout");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<bm-variable-grid\n\t\t\t.info=\"", "\"\n\t\t\t.items=\"", "\"\n\t\t\t.R=\"", "\"\n\t\t\t.C=\"", "\"\n\t\t\tstyle=\"", "\"\n\t\t></bm-variable-grid>\n\t"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host {\n\t\t\t\t\tgrid-template-columns: repeat(var(--cols-count), 1fr) auto;\n\t\t\t\t\tgrid-gap: 0;\n\t\t\t\t\tplace-items: center center;\n\t\t\t\t}\n\t\t\t\t.field,\n\t\t\t\t.th {\n\t\t\t\t\tmargin: var(--gap, 0);\n\t\t\t\t}\n\t\t\t\t.header {\n\t\t\t\t\tgrid-column: 1 / -1;\n\t\t\t\t\tgrid-row: 1 / 1;\n\t\t\t\t\tbackground-color: rgba(0, 53, 101, 0.1);\n\t\t\t\t\tbackground-color: var(--translucent-color, rgba(0, 53, 101, 0.1));\n\t\t\t\t}\n\t\t\t\t.border {\n\t\t\t\t\tborder-bottom: 1px solid rgb(213, 212, 217);\n\t\t\t\t\talign-self: stretch;\n\t\t\t\t\tjustify-self: stretch;\n\t\t\t\t}\n\t\t\t\t.border.row {\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t}\n\t\t\t\t.border.container {\n\t\t\t\t\tborder: 1px solid rgb(213, 212, 217);\n\t\t\t\t\tborder-bottom: 0;\n\t\t\t\t}\n\t\t\t\tbm-expansion-panel-add-button {\n\t\t\t\t\tgrid-column: 1 / -1;\n\t\t\t\t\tplace-self: stretch stretch;\n\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t}\n\n\t\t\t\t.remove-btn-cell {\n\t\t\t\t\tjustify-self: center;\n\t\t\t\t}\n\t\t\t\t.var-grid-remove-btn {\n\t\t\t\t\theight: 22px;\n\t\t\t\t\tbox-sizing: content-box;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<button\n\t\t\t\tclass=\"bm-button xs primary outline var-grid-remove-btn\"\n\t\t\t\t@click=\"", "\"\n\t\t\t\t?disabled=\"", "\"\n\t\t\t\t>\n\t\t\t\t", "\n\t\t\t</button>\n\t\t"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-expansion-panel-add-button\n\t\t\t\t.addButtonLabel=\"", "\"\n\t\t\t\t@click=\"", "\"\n\t\t\t></bm-expansion-panel-add-button>\n\t\t"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<span class=\"border container\" style=\"", "\"></span>\n\t\t"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"border row\" style=\"", "\"></span>"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t", "\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"header border\"></span>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<span class=\"th\" style=\"", "\">", "</span>\n\t\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<span\n\t\t\t\tclass=\"field remove-btn-cell\"\n\t\t\t\tstyle=\"", "\">\n\t\t\t\t", "\n\t\t\t</span>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmVariableGridLayout = /*#__PURE__*/function (_bmVariableLayout) {
  (0, _inherits2.default)(BmVariableGridLayout, _bmVariableLayout);

  var _super = (0, _createSuper2.default)(BmVariableGridLayout);

  function BmVariableGridLayout() {
    (0, _classCallCheck2.default)(this, BmVariableGridLayout);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmVariableGridLayout, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changed) {
      if (!(0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout.prototype), "shouldUpdate", this).call(this, changed)) {
        return false;
      }

      this.setDefaultOptions();
      return true;
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout.prototype), "setDefaultOptions", this).call(this);
    }
  }, {
    key: "sortPositions",
    value: function sortPositions(_) {
      var _this = this;

      var subRowGridPositions = [];
      var children = this.info.options.order;

      var _loop = function _loop(i) {
        var _context2;

        var childName = children[i];
        var gridOpts = _this.items[childName].layout.options;
        var baseRow = _this.R * i + 1;

        var _subRowGridPositions = (0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout.prototype), "sortPositions", _this).call(_this, gridOpts.position, {
          baseRow: baseRow
        });

        _subRowGridPositions = (0, _map.default)(_subRowGridPositions).call(_subRowGridPositions, function (_ref) {
          var _context;

          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
              grandchildName = _ref2[0],
              pos = _ref2[1];

          var name = (0, _concat.default)(_context = "".concat(grandchildName, ".")).call(_context, childName);
          return [name, pos];
        });
        subRowGridPositions.push.apply(subRowGridPositions, (0, _toConsumableArray2.default)(_subRowGridPositions));
        var g = [(0, _concat.default)(_context2 = "__removebtn__.".concat(childName, ".")).call(_context2, i.toString()), {
          columns: 1,
          rows: 1,
          rowSpan: baseRow,
          colSpan: _this.C
        }];
        subRowGridPositions.push(g);
      };

      for (var i = 0; i < children.length; ++i) {
        _loop(i);
      }

      return subRowGridPositions;
    }
  }, {
    key: "rebasePosition",
    value: function rebasePosition(posOpts) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$baseCol = _ref3.baseCol,
          baseCol = _ref3$baseCol === void 0 ? 0 : _ref3$baseCol,
          _ref3$baseRow = _ref3.baseRow,
          baseRow = _ref3$baseRow === void 0 ? 0 : _ref3$baseRow;

      posOpts.rowSpan += baseRow;
      posOpts.colSpan += baseCol;
      return posOpts;
    }
  }, {
    key: "render",
    value: function render() {
      var columnHeaders = this.info.options.columnHeaders;
      var headerRow = this.renderHeaderRow(columnHeaders);
      var borderTags = this.renderBorders(this.R);
      var addButton = this.renderAddButton(this.info.options.hideAdd);
      return this.html(_templateObject(), headerRow, borderTags, (0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout.prototype), "render", this).call(this), addButton);
    }
  }, {
    key: "renderField",
    value: function renderField(_ref4) {
      var _this2 = this;

      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          name = _ref5[0],
          position = _ref5[1];

      if ((0, _includes.default)(name).call(name, '__removebtn__')) {
        var _name$split = name.split('.'),
            _name$split2 = (0, _slicedToArray2.default)(_name$split, 3),
            rowName = _name$split2[1],
            idx = _name$split2[2];

        var hideRemoveOpts = this.info.options.hideRemove;
        var removeButtonLabel = this.info.options.removeButtonLabel;
        var numRows = this.info.options.order.length;
        return (0, _element.guard)([hideRemoveOpts, name, position, removeButtonLabel, numRows], function () {
          return _this2.renderRemoveCell(_this2.info.options.hideRemove, rowName, Number(idx), position, removeButtonLabel, numRows);
        });
      }

      var itemInfo = this.getItem(name);
      return (0, _element.guard)([itemInfo, position], function () {
        return _this2._renderField(itemInfo, position);
      });
    }
  }, {
    key: "renderRemoveCell",
    value: function renderRemoveCell(opts, rowName, idx, position, label, numRows) {
      var colSpan = position.colSpan,
          rowSpan = position.rowSpan,
          columns = position.columns,
          rows = position.rows;
      var gridFieldStyles = (0, _element.styleMap)({
        '--field-col-start': (colSpan + 1).toString(),
        '--field-col-end': (colSpan + 1 + columns).toString(),
        '--field-row-start': (rowSpan + 1).toString(),
        '--field-row-end': (rowSpan + 1 + rows).toString()
      });
      return this.html(_templateObject2(), gridFieldStyles, this.renderRemoveButton(opts, idx, rowName, label, numRows));
    }
  }, {
    key: "getItem",
    value: function getItem(name) {
      var _name$split3 = name.split('.'),
          _name$split4 = (0, _slicedToArray2.default)(_name$split3, 2),
          grandchildName = _name$split4[0],
          childName = _name$split4[1];

      var info = this.items[childName].options.items[grandchildName];
      return info;
    }
  }, {
    key: "renderHeaderRow",
    value: function renderHeaderRow(headers) {
      var _this3 = this;

      if (!(0, _utils.isDefined)(headers)) return null;
      var headerCells = (0, _map.default)(headers).call(headers, function (header, idx) {
        var _context3;

        var styles = {
          'grid-column': (0, _concat.default)(_context3 = "".concat(header.colSpan + 1, " / span ")).call(_context3, header.columns || 1),
          'grid-row': '1 / 1'
        };
        header.label.name = header.label.name || idx.toString();
        var labelItem = (0, _itemFactory.createItem)(header.label, null, null, null);

        var labelItemElt = _this3.renderItem(labelItem);

        return _this3.html(_templateObject3(), (0, _element.styleMap)(styles), labelItemElt);
      });
      var headerBorder = this.html(_templateObject4());
      return this.html(_templateObject5(), headerCells, headerBorder);
    }
  }, {
    key: "renderBorders",
    value: function renderBorders(R) {
      var _context4,
          _this4 = this;

      var rows = this.info.options.order;
      if (rows.length === 0) return null;
      var borderTags = (0, _map.default)(_context4 = (0, _from.default)({
        length: rows.length
      })).call(_context4, function (_, idx) {
        var _context5;

        var rowStart = idx * R + 1 + 1;
        var borderStyles = (0, _element.styleMap)({
          'grid-column': '1 / -1',
          'grid-row': (0, _concat.default)(_context5 = "".concat(rowStart, " / ")).call(_context5, rowStart + R)
        });
        return _this4.html(_templateObject6(), borderStyles);
      });
      var containerBorderStyle = (0, _element.styleMap)({
        'grid-column': '1 / -1',
        'grid-row': '1 / -1'
      });
      var containerBorder = this.html(_templateObject7(), containerBorderStyle);
      borderTags.push(containerBorder);
      return borderTags;
    }
  }, {
    key: "renderAddButton",
    value: function renderAddButton() {
      var hideAdd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (hideAdd) return null;
      return this.html(_templateObject8(), this.info.options.addButtonLabel, this.addRow);
    }
  }, {
    key: "renderRemoveButton",
    value: function renderRemoveButton(opts, idx, rowName, removeButtonLabel, numRows) {
      var _this5 = this;

      if (this.shouldHideRemove(opts, rowName)) return null;

      var onRemoveRow = function onRemoveRow(evt) {
        if (idx > 0) {
          _this5.removeRow(evt, idx);
        }
      };

      return this.html(_templateObject9(), onRemoveRow, numRows === 1, removeButtonLabel);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-variable-grid';
    }
  }, {
    key: "properties",
    get: function get() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout), "properties", this)), {}, {
        R: {
          type: Number,
          attribute: false,
          reflect: false
        },
        C: {
          type: Number,
          attribute: false,
          reflect: false
        }
      });
    }
  }, {
    key: "styles",
    get: function get() {
      return [(0, _get2.default)((0, _getPrototypeOf2.default)(BmVariableGridLayout), "styles", this), _uiElements.bmButtonStyle, (0, _element.css)(_templateObject10())];
    }
  }]);
  return BmVariableGridLayout;
}((0, _renderVariableLayout.bmVariableLayout)(_renderGridLayout.BmGridLayout));

exports.BmVariableGridLayout = BmVariableGridLayout;

function registerBmVariableGridLayoutElement() {
  (0, _uiElements.registerBmExpansionPanelAddButton)();
  (0, _element.register)(BmVariableGridLayout);
}

var renderBmVariableGridLayout = function renderBmVariableGridLayout(info, items) {
  var numTotRows;
  var R;
  var C;
  var styles = null;

  if (info && items) {
    var children = info.options.order;
    var N = children.length;

    var _items = (0, _map.default)(children).call(children, function (itemName) {
      return items[itemName];
    });

    styles = getVariableGridStyles(_items);
    numTotRows = Number(styles['--rows-count']);
    C = Number(styles['--cols-count']);
    R = numTotRows / N;
  }

  return (0, _element.html)(_templateObject11(), info, items, R, C, (0, _element.styleMap)(styles || {}));
};

exports.renderBmVariableGridLayout = renderBmVariableGridLayout;

function getVariableGridStyles(children) {
  var firstItemGrid = children[0].layout;
  var styles = (0, _renderGridLayout.getGridStyles)(firstItemGrid.options);
  var numRows = children.length;
  var R = Number(styles['--rows-count']);
  styles['--rows-count'] = (numRows * R).toString();
  return styles;
}

function registerBmVariableGridLayout() {
  (0, _layoutRegistry.registerLayout)('variable-grid', {
    renderer: renderBmVariableGridLayout,
    dependents: BmVariableGridLayout.dependents
  });
  registerBmVariableGridLayoutElement();
}
